import { render, staticRenderFns } from "./CowsNosePunching.vue?vue&type=template&id=4fb9791c&scoped=true&"
import script from "./CowsNosePunching.vue?vue&type=script&lang=js&"
export * from "./CowsNosePunching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb9791c",
  null
  
)

export default component.exports